import types from './mutation-types';

export default {
	[types.SET_STATE]: (state, { key, value }) => {
		state[key] = value;
	}
};
